import React, { Component } from "react";
import {format_date_only, formatNumber, randomHex, format_display_fancy_notime} from '../../Utils';
import moment from 'moment';
import "../../css/agentreport.css";
import XLSX from 'xlsx';
import {UserService} from '../../Services/UserService';
import { ReportService } from "../../Services/ReportService";
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button, Grid, TextField } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { Autocomplete } from "@material-ui/lab";
import { Line } from "react-chartjs-2";

const styles = theme =>({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    }
  });

class AgentReport extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        startDate: moment().startOf('d').subtract(7, "days"),
        endDate: moment().startOf('d'),
        message : "",
        userList: [],
        selectedAgent: [],
        totalAmount: 0,
        total_returns: 0,
        lineData: {},
        lineReturnsData: {},
        labels: [],
        lineOptions: {
            responsive : true, 
            maintainAspectRatio: false, 
            onClick: null, 
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        var dataset = data.datasets[tooltipItem.datasetIndex];
                        var currentValue = dataset.data[tooltipItem.index];
                        // return " Count: " + currentValue + ' (' + percentage + '%)';
                        return formatNumber(currentValue);
                    },
                    title: function(tooltipItem, data) {
                        return moment(data.labels[tooltipItem[0].index]).format(format_display_fancy_notime);
                    }
                }
            },
            scales: {
                xAxes: [
                    {
                        type: 'time',
                        time: {
                            unit: 'day',
                            displayFormats: {
                                week : "ll",
                                month: "MMM YYYY"
                            },
                            //unitStepSize: daily_sales_option === 0 ? 10  : undefined
                        },
                        display: true,
                        gridLines: {display: true}
                    }
                ],
                yAxes: [{
                    ticks: {
                        callback: function(label, index, labels) {
                        return formatNumber(label)
                        }
                    }
                }]
            }
        }
      }

      props.setTitle('Agents Performance Report');

      this.handleChangeStart = this.handleChangeStart.bind(this);
      this.handleChangeEnd = this.handleChangeEnd.bind(this);
      this.today = this.today.bind(this);
    }
    
    componentWillMount(){
        this.props.isLoading(true);
        UserService.getAgentList()
        .then((data) => {
            console.log(data);
            this.setState({userList: data.users});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    today(e){
        e.preventDefault();
        if(this.state.selectedAgent.length > 0){
            this.setState({ 
                startDate: moment().startOf('d'),
                endDate: moment().startOf('d')
            }, () => {
                this.fetchData();
            });
        } else {
            this.props.showSnackBar('Select Agents to Generate Report', 'error');
        }
    }

    fetchData(){
        if(this.state.selectedAgent.length > 0){
            this.props.isLoading(true);
            
            let agents = this.state.selectedAgent.map(a => a.id);

            ReportService.getAgentPerformanceGraph(this.state.startDate, this.state.endDate, agents.join(','))
            .then((data) => {
                console.log(data);
                let labels = new Set();
                let agentData = new Map();
                let agentReturnsData = new Map();

                data.report.forEach((element, index) => {
                    if(!agentData.has(element.delivery_agent_id)){
                        agentData.set(element.delivery_agent_id, []);
                        agentReturnsData.set(element.delivery_agent_id, []);
                    }
                    let d = agentData.get(element.delivery_agent_id);
                    let r = agentReturnsData.get(element.delivery_agent_id);
                    d.push(parseFloat(element.total_amount));
                    r.push(parseFloat(element.total_return_amount));
                    labels.add(element.schedule_date);
                });

                let datasets = [], datasetsReturns = [];
                agents.forEach(agent => {
                    let name = this.state.userList.filter(u => u.id === agent)[0].name;
                    let color = randomHex();
                    datasets.push({
                        label: name,
                        data: agentData.get(agent),
                        backgroundColor: '#FFF',
                        borderColor: color,
                        borderWidth: 1,
                        fill: false,
                        pointRadius: 2,
                    });

                    datasetsReturns.push({
                        label: name,
                        data: agentReturnsData.get(agent),
                        backgroundColor: '#FFF',
                        borderColor: color,
                        borderWidth: 1,
                        fill: false,
                        pointRadius: 2,
                    });
                });
                let lineData = {
                    labels: [...labels],
                    datasets: datasets
                };

                let lineReturnsData = {
                    labels: [...labels],
                    datasets: datasetsReturns
                };
                this.setState({lineData, lineReturnsData, data: data.report, labels: [...labels]});
                if(data.report.length === 0) {
                    this.setState({message: "No Data available."});
                }
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
        }
    }
    
    handleChangeStart(date){
        this.setState({
            startDate: date.startOf('d')
        });
    }

    handleChangeEnd(date){
        this.setState({
            endDate: date.startOf('d')
        });
    }

    handleSelection = (e, selectedAgent) => {
        this.setState({selectedAgent});
    }

    export = (e) => {
        let filename = 'Agent Performance Report';
        let sheetname = 'Sales Report';
        let returnsSheetname = 'Returns Report';
        let exportData = [], exportReturnsData = [];
        exportData = [[sheetname]];
        exportReturnsData = [[returnsSheetname]];
        let agents = this.state.selectedAgent.map(a => a.name.toUpperCase());
        let agentsId = this.state.selectedAgent.map(a => a.id);
        exportData =[['', ...agents]];
        exportReturnsData =[['', ...agents]];
        this.state.labels.forEach((l) => {
            let row = [], returnsRow = [];
            agentsId.forEach(a => {
                let v = this.state.data.filter(f => f.schedule_date === l && f.delivery_agent_id === a);
                row.push(parseFloat(v.length > 0 ? v[0].total_amount : 0));
                returnsRow.push(parseFloat(v.length > 0 ? v[0].total_return_amount : 0));
            })
            exportData.push([moment(l).format(format_display_fancy_notime), ...row]);
            exportReturnsData.push([moment(l).format(format_display_fancy_notime), ...returnsRow]);
        });
        let totalRow = ['Total'], totalReturnsRow = ['Total'];
        agentsId.forEach(a => {
            totalRow.push(this.state.data.filter(f => f.delivery_agent_id === a).reduce((sum, next) => sum + parseFloat(next.total_amount || 0), 0));
            totalReturnsRow.push(this.state.data.filter(f => f.delivery_agent_id === a).reduce((sum, next) => sum + parseFloat(next.total_return_amount || 0), 0));
        });
        exportData.push(totalRow);
        exportReturnsData.push(totalReturnsRow);
            
        if(exportData.length > 0 || exportReturnsData.length > 0){
            const wb = XLSX.utils.book_new();
            const wsAll = XLSX.utils.aoa_to_sheet(exportData);
            const wsAllR = XLSX.utils.aoa_to_sheet(exportReturnsData);
            XLSX.utils.book_append_sheet(wb, wsAll, sheetname);
            XLSX.utils.book_append_sheet(wb, wsAllR, returnsSheetname);
            XLSX.writeFile(wb, filename + ".xlsx");
        } else {
            this.props.showSnackBar('No data to Export', 'warning');
        }
    }
    
    render() {
        const message = this.state.message;
        const {classes} = this.props;
        return (
            <div className="Home agent_report" style={{marginTop: 32}}>
                <Paper style={{paddingTop: 8, paddingBottom: 8}}>
                    <Grid container style={{paddingLeft: 8, paddingRight: 8}}>
                        <Grid item xs={12} lg={4} style={{marginTop: 16}}>
                            <Autocomplete
                                multiple
                                id="agent-selection"
                                options={this.state.userList}
                                getOptionLabel={option => (option && option.name) || ''}
                                value={this.state.selectedAgent || []}
                                required={true}
                                onChange={this.handleSelection}
                                className={classes.autoCompleteSelectionTextField}
                                style={{ zIndex: 9999 }}
                                renderInput={params => (
                                    <TextField {...params} label="Select Agent" variant="outlined" fullWidth />
                                )}
                                />
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                        variant="inline"
                                        inputVariant="outlined"
                                        margin="normal"
                                        label="From"
                                        value={this.state.startDate}
                                        onChange={this.handleChangeStart}
                                        format={format_date_only}
                                        maxDate={this.state.endDate}
                                        className={classes.formControl}
                                        InputLabelProps={{
                                            style: { zIndex: 'auto' }
                                        }}
                                    />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6} lg={2}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    variant="inline"
                                    inputVariant="outlined"
                                    margin="normal"
                                    label="To"
                                    value={this.state.endDate}
                                    onChange={this.handleChangeEnd}
                                    format={format_date_only}
                                    minDate={this.state.startDate}
                                    className={classes.formControl}
                                    InputLabelProps={{
                                        style: { zIndex: 'auto' }
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} lg={4} style={{marginTop: 24}}>
                            <Button variant="outlined" style={{marginRight: 8}} color="primary" onClick={(e) => { this.today(e)}}>TODAY</Button>
                            <Button variant="outlined" style={{marginRight: 8}} onClick={(e) => { this.fetchData(e)}}>Generate</Button>
                            <Button variant="contained" color="primary" disabled={this.state.data.length === 0} onClick={this.export}>Export</Button>
                        </Grid>
                    </Grid>
                    </Paper>
                    {
                        this.state.data.length > 0 &&
                        <Paper style={{paddingTop: 8, paddingBottom: 30, marginTop: 20, paddingRight: 10, height: '60vh'}}>
                                <Typography variant="body2">Daily Sales</Typography>
                                <Line options={this.state.lineOptions} data={this.state.lineData}/>
                        </Paper>
                    }
                    {
                        this.state.data.length > 0 &&
                        <Paper style={{paddingTop: 8, paddingBottom: 30, marginTop: 20, paddingRight: 10, height: '60vh'}}>
                                <Typography variant="body2">Daily Returns</Typography>
                                <Line options={this.state.lineOptions} data={this.state.lineReturnsData}/>
                        </Paper>
                    }
                    {
                        message && 
                        (
                            <p style={{color:"red", marginTop: '10vh'}}>{message}</p>
                        )
                    }
            </div>
        );
    }

}

export default withStyles(styles)(AgentReport);